
import { defineComponent } from 'vue';

type LinkItems = { label: string; value: string };

export default defineComponent({
	props: {
		title: {
			required: true,
			type: String,
		},
		items: {
			required: true,
			type: Array as () => Array<LinkItems>,
		},
		itemLabel: {
			default: 'label',
			type: String,
		},
		itemValue: {
			default: 'value',
			type: String,
		},
		notifications: {
			default: () => ({}),
			type: Object as () => Record<string, number>,
		},
		selectedItem: {
			required: true,
			type: String,
		},
	},
	setup(props, { emit }) {
		const emitSelected = (e: string) => {
			emit('update:selected-item', e);
			emit('set-item', e);
		};

		return { emitSelected };
	},
});
